/**
 * O que acontece na tela do operador quando o CLIENTE encerra a conversa.
 *
 * Pedido da Gisele (15/10/2026). O aviso já existia -- som, notificação e
 * sininho --, mas a conversa ficava parada no acesso rápido, apontando para um
 * chat morto. E ela pediu também que abrisse o ticket, "igual quando o
 * operador finaliza".
 *
 * ## Por que isto é um módulo, e não duas linhas no handler do socket
 *
 * Porque o handler vive dentro do provider do socket.io, e testar aquilo
 * significa simular conexão, evento e store. As duas decisões abaixo são
 * puras -- entra estado, sai resposta -- e é nelas que mora a regra.
 */

/**
 * As abas do acesso rápido sem a conversa que acabou.
 *
 * Compara como TEXTO: o `room_id` da aba vem do estado (que passou por
 * `localStorage`, onde tudo vira string) e o do evento vem do socket. Comparar
 * com `===` cru deixaria `'12' !== 12` e a aba sobreviveria -- que é
 * exatamente o defeito que este módulo conserta.
 */
export const abasSemASala = (abas, roomId) => {
    const lista = Array.isArray(abas) ? abas : [];

    if (roomId === null || roomId === undefined || roomId === '') return lista;

    return lista.filter((aba) => String(aba?.room_id) !== String(roomId));
};
